<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://agrovisioncorp.com/"
        target="_blank"
      >Agrovision Perú SAC</b-link>
      <span class="d-none d-sm-inline-block">, Todos los derechos reservados</span>
    </span>

    <span class="float-md-right d-none d-md-block">Aplicaciones de Software

      <font-awesome-icon icon="fa-solid fa-code" class="text-danger stroke-current" />

    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCode } from '@fortawesome/free-solid-svg-icons'
library.add( faCode )

export default {
  components: {
    BLink,
  },
}
</script>
